import { Injectable } from '@angular/core';
import { ODataService } from '../../../core/services/oData.service';
import { AddressType } from './address-type';

@Injectable({
  providedIn: 'root'
})
export class AddressTypeService extends ODataService<AddressType> {
  public url = 'AddressType';
}